<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">Behfa Equipment in Group '{{inner_DeviceBehfaFilterGroup.title}}'</h5>
      <br />
      <br />
      <div class="row">
        <div class="form-group col-md-6">
          <button *ngIf="!Procssing" type="button" style="margin-right: 10px;" (click)="openModal_DeviceBehfa(templateDeviceBehfa)"
              class="btn btn-success"> Select Behfa Equipment <i class="fa fa-building"></i> </button>

          <button  (click)="onBack()" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> Back </button>
          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Description</th>
              <th>Manufacturer</th>
              <th>Model</th>
              <th>Code BEHFA</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_DeviceBehfaFilterGroupUser
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_DeviceBehfaFilterGroupUser).length
                      }
            ">
              <td>{{DataList_DeviceBehfaFilterGroupUser.indexOf(item)+1}}</td>
              <td class="EnglishClm">{{item.description}}</td>
              <td class="EnglishClm">{{item.manufacturer}}</td>
              <td class="EnglishClm">{{item.model}}</td>
              <td class="EnglishClm">{{item.codeBEHFA}}</td>
              <td style="cursor: pointer;">
                <button (click)="Delete(item)" *ngIf="!Procssing"
                  class="btn btn-danger"><i class="fa fa-remove"></i> Delete </button>
              </td>


            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_FeildTable" nextLabel="Next" previousLabel="Previous" (pageChange)="page = $event">
    </pagination-controls>
  </div>
</div>

<ng-template #templateDeviceBehfa>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Behfa Equipment List </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_DeviceBehfa.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <app-DeviceBehfaActiveList [inner_PersianDate]=""
      [inner_SeletedDeviceBehfa]="DataList_DeviceBehfaFilterGroupUser"
      (seleted_DeviceBehfa_Interface)="Set_Selected_DeviceBehfa_Record($event)">

    </app-DeviceBehfaActiveList>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="modalRef_DeviceBehfa.hide()">Close</button>
  </div>
</ng-template>